"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sweetalert2_js_1 = require("sweetalert2/dist/sweetalert2.js");
var toastr = require("toastr");
function updateCartViews(data) {
    if (data.hasOwnProperty('templates')) {
        $.each(data.templates, function (templateName, templateHtml) {
            // @ts-ignore
            var $element = $('[data-cart-template="' + templateName + '"]', 'body');
            if ($element.length) {
                $element.children().remove();
                $element.append(templateHtml);
                if ($('.undeliverableAddress').length) {
                    sweetalert2_js_1.default({
                        type: 'error',
                        title: '',
                        html: true,
                        text: $('.undeliverableAddress').html()
                    });
                }
            }
            else if (templateName == 'cart-popup') {
                toastr.success(templateHtml);
            }
            else if (templateName == 'cart-popup-html') {
                $('[data-append-template="' + templateName + '"]')
                    .empty()
                    .append(templateHtml);
            }
        });
    }
    // Si la requète dispose de données pour la datalayer GTM et que la classe
    // JS de GTM est chargée alors on les transferts
    console.log('before dataLayer.push(data.gtm[k]);');
    // @ts-ignore
    if (typeof dataLayer !== 'undefined' && data.gtm !== undefined) {
        // Envoi des données à GTM
        Object.keys(data.gtm).forEach(function (k) {
            console.log('dataLayer.push(data.gtm[k]);');
            // @ts-ignore
            dataLayer.push(data.gtm[k]);
        });
    }
}
exports.default = updateCartViews;
